/**
 * Checks if a value is not null or undefined.
 * @template Type - The type of the value.
 * @param value - The value to check.
 * @returns `true` if the value is not null or undefined, `false` otherwise.
 */
export function isT<Type>(value: Type | null | undefined): value is Type {
  return value !== null && value !== undefined;
}
